import {CommonStatus} from "@/enums/status";

export class CustomerServiceParams {
    page? = 1;
    limit? = 20;
    search?: string;
    status?: CommonStatus = CommonStatus.Active;
    fromDate?: number;
    toDate?: number;
    provinceId?: number;
    districtId?: number;
    createdByRowGuid?: string;
    employeeRowGuid?: string;
}
